const getFirebaseErrorMessage = (errorCode:string) => {  
    switch (errorCode) {
        case 'auth/invalid-credential':
            return 'Invalid credential.';
        case 'auth/email-already-exists':
            return 'Email already exists. Please login.';
        case 'auth/id-token-expired':
            return 'Session expired. Please login again.';
        case 'auth/insufficient-permission':
            return 'Insufficient permission to perform the operation.';
        case 'auth/invalid-email':
            return 'Invalid email address.';
        case 'auth/user-disabled':
            return 'User account disabled.';
        case 'auth/invalid-password':
            return 'Invalid password.';
        case 'auth/email-already-in-use':
            return 'Email already in use.';
        default:
            return 'An error occurred. Please try again in a few minutes.';
    }
};

export { getFirebaseErrorMessage };
